import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const storeApprovalStatusesAdapter = getAdapter({ idFieldName: 'value' });

const storeApprovalStatusesSlice = createSlice({
  name: 'storeApprovalStatuses',
  initialState: storeApprovalStatusesAdapter.getInitialState(),
  reducers: {
    setStoreApprovalStatuses: (state, { payload: { storeApprovalStatuses } }) => {
      storeApprovalStatusesAdapter.setAll(state, storeApprovalStatuses);
    },
  },
});

const selectors = storeApprovalStatusesAdapter.getSelectors(({ storeApprovalStatuses }) => storeApprovalStatuses);

export const getStoreApprovalStatuses = (state) => selectors.selectAll(state);

export const {
  setStoreApprovalStatuses,
} = storeApprovalStatusesSlice.actions;

export default storeApprovalStatusesSlice.reducer;
